import { createClient } from '@supabase/supabase-js'

// Project configuration for direct connection
const SUPABASE_URL = 'https://zqwjmsifflsdmfyjdgpo.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpxd2ptc2lmZmxzZG1meWpkZ3BvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg5OTMzOTYsImV4cCI6MjA5NDU2OTM5Nn0.Oct6sBI60rCahc6JcNQOaQ2JVyGQmDrsSipt2edFteQ'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})